/**
 *
 * PermissionProvider
 *
 */
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import PropTypes from 'prop-types';
import { useInjectReducer, useInjectSaga } from 'redux-injectors';

// Components
// Hooks
import { useUser } from '../../../hooks';
import BootGate from '../BootProvider/BootGate';
import * as actions from './actions';
import reducer from './reducer';
import saga from './saga';
import usePermissions from './usePermissions';

export function PermissionProvider(props) {
  useInjectReducer({ key: 'permissionProvider', reducer });
  useInjectSaga({ key: 'permissionProvider', saga });

  const { children } = props;

  // Hooks
  const dispatch = useDispatch();

  // Custom hooks
  const { isAuthenticated } = useUser();

  // States
  const [sessionVerified, setSessionVerified] = useState(false);

  const callback = useCallback(() => {
    setTimeout(() => setSessionVerified(true), 250);
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(actions.retrieveRequest({ callback }));
    } else {
      setSessionVerified(true);
    }
  }, [isAuthenticated, sessionVerified, dispatch, callback]);

  if (sessionVerified) return children;

  return <BootGate />;
}

PermissionProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PermissionProvider;
export { usePermissions };
